import React, { createContext, useContext, useState, useMemo } from "react";

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState([]);
  const [currentPurchase, setCurrentPurchase] = useState(null);

  const addToCart = (bot) => {
    setCartItems((prev) => {
      const existing = prev.find((item) => item.id === bot.id);
      if (existing) {
        return prev.map((item) =>
          item.id === bot.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      }
      return [...prev, { ...bot, quantity: 1 }];
    });
  };

  const removeFromCart = (botId) => {
    setCartItems((prev) =>
      prev
        .map((item) =>
          item.id === botId
            ? { ...item, quantity: item.quantity - 1 }
            : item
        )
        .filter((item) => item.quantity > 0)
    );
  };

  const buyNow = (bot) => {
    setCurrentPurchase({ ...bot, quantity: 1 });
  };

  const purchaseCart = () => {
    // You can replace this with actual purchase logic (e.g., API call)
    setCurrentPurchase([...cartItems]);
    setCartItems([]);
  };

  const totalPrice = useMemo(() => {
    return cartItems.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );
  }, [cartItems]);
  const cartCount = useMemo(() => {
    return cartItems.reduce((total, item) => total + item.quantity, 0);
  }, [cartItems]);


  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        currentPurchase,
        buyNow,
        purchaseCart,
        totalPrice,
        cartCount,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
